import React from "react";
import { Link } from "react-router-dom";
import { List, Layout, Card, Collapse } from "antd";

import UNSWLogo from "./img/unsw.png";

const { Content } = Layout;

export default class Home extends React.Component {
  render() {
    if (this.props.modules)
      return (
        <Content
          style={{
            display: "flex",
            flexFlow: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0, 0, 0, 0.5)",
            padding: 32
          }}
        >
          <Card
            title={
              <div>
                <img
                  alt="UNSW Logo"
                  src={UNSWLogo}
                  style={{
                    display: "block",
                    width: "75%",
                    maxWidth: 220,
                    margin: "0 auto",
                    marginBottom: 12
                  }}
                />
                <span
                  style={{
                    fontSize: 24,
                    fontWeight: "bold",
                    fontFamily: "Times New Roman, Times, serif"
                  }}
                >
                  Materials Characterisation
                </span>
              </div>
            }
            style={{
              width: 600,
              height: 600,
              maxWidth: "100%",
              background: "rgba(255, 255, 255, 1)",
              borderRadius: 4,
              boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.2)"
            }}
            bodyStyle={{ padding: 0 }}
          >
            <Collapse accordion bordered={false}>
              {this.props.modules.map((module, i) => {
                return (
                  <Collapse.Panel
                    key={i}
                    header={
                      <div
                        style={{
                          display: "flex",
                          fontSize: 20,
                          fontWeight: "lighter"
                        }}
                      >
                        {module.group_name}
                      </div>
                    }
                  >
                    <List
                      dataSource={module.modules}
                      renderItem={item => {
                        return (
                          <Link
                            style={{ color: "rgba(0, 0, 0, 0.85" }}
                            to={`/${item.folder}`}
                          >
                            <Card.Grid
                              style={{ minWidth: 128, minHeight: 128 }}
                            >
                              <div style={{ fontSize: 16 }}>{item.title}</div>
                              {item.description}
                            </Card.Grid>
                          </Link>
                        );
                      }}
                    />
                  </Collapse.Panel>
                );
              })}
            </Collapse>
          </Card>
        </Content>
      );

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/Home.js